<template>
  <div class="wrap" id="i-detail-wrap">
    <div style="width:100%" v-if="mounted">
      <div :class="[child == true ? 'header-individual-child' : header_notification ? 'header-individual full header-notification-space' : 'header-individual full']">
        <div class="search-form">
          <div class="header-tabs" @click="tabs != 'summary' ? changeTab('summary') : ''" :class="tabs == 'summary' ? 'active' : ''">サマリー</div>          
          <div class="header-tabs" @click="tabs != 'analysis' ? changeTab('analysis') : ''" :class="tabs == 'analysis' ? 'active' : ''">分析</div>
          <div class="header-tabs" @click="tabs != 'post' ? changeTab('post') : ''" :class="tabs == 'post' ? 'active' : ''">動画</div>
          <div class="header-tabs" @click="tabs != 'note' ? changeTab('note') : ''" :class="tabs == 'note' ? 'active' : ''">ノート</div>
          <otherSNS :own_id="profile_data.tt_id" :other_sns="profile_data.other_sns" :similar_data="similar_data" :parent_component="parent_component" :child="child" />
        </div>
        <div class="flex"></div>
        <div class="i-detail-similar-button-wrap pointer" v-if="similar_data && !similar_loading" @click="scrollBottom()">
          <div class="i-detail-similar-icon" v-for="similar in similar_account" :key="similar.account_name">
            <el-image :src="similar.profile_picture_url" class="i-detail-header-sns-img" style="border:1px solid #fff">
              <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
            </el-image>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
        <div v-if="similar_loading" class="i-detail-similar-button-wrap pointer">
          <div v-for="n in 5" :key="n">
            <div class="i-detail-similar-icon"><div class="i-detail-header-sns-img data-table-profile-noimg w-border"></div></div>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
      </div>

      <div class="i-detail-wrap" v-show="!loading" :class="child == true ? 'child' : ''">
        <div class="i-detail-user-page">
          <!-- プロフィール部分 -->
          <div class="profile" :style="tabs == 'post' || tabs == 'note' ? 'margin-bottom:0px' : ''">
            <div class="profile-left">
              <div class="profile-img-area" :class="tabs != 'summary' ? 'minimize' : ''">
                <div class="profile-img-wrap">
                  <el-tooltip placement="bottom">
                    <div slot="content" style="font-size:10px">
                      お気に入り<span>{{ profile_data.favorite == 0 ? "に追加" : "から削除" }}</span>
                    </div>
                    <div class="profile-img-favorite" :class="[tabs != 'summary' ? 'minimize' : '', profile_data.favorite == 0 ? 'off' : '']" @click="favorite"><font-awesome-icon icon="star" /></div>
                  </el-tooltip>
                  <el-image class="profile_img" :class="tabs != 'summary' ? 'minimize' : ''" :src="profile_data.profile_picture_url">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                </div>
              </div>
              <div class="profile-gender-area" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile-title">
                  フォロワーの男女比率&nbsp;
                  <el-tooltip placement="top">
                    <div slot="content">AIにより算出したフォロワーの男女比です。<br />実際の数値とは異なる場合があります。<br />
                    またフォロワーの性別データが不十分な場合は表示されません。</div>
                    <span><font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;"/></span>
                  </el-tooltip>
                </div>
                
                <el-radio-group v-show="profile_data.audience" v-model="graph_gender" size="mini" style="margin-bottom: 10px;">
                    <el-radio-button label="全て"></el-radio-button>
                    <el-radio-button label="女性"></el-radio-button>
                    <el-radio-button label="男性"></el-radio-button>
                </el-radio-group>
                
                <genderBar :profile_data="profile_data" :graph_gender="graph_gender"/>
              </div>
              <!-- <div class="profile-category" v-show="tabs == 'summary' || tabs == 'post'">
                <div class="profile-title">
                  関連カテゴリ&nbsp;
                  <el-tooltip placement="top">
                    <div slot="content">YouTubeで定義されているカテゴリです。</div>
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div class="category" v-if="profile_data.topicIds">
                  <div class="category-box pointer" v-for="category in profile_data.topicIds" v-bind:key="category.id" @click="searchMedia('category', category.topic_name)">
                    <font-awesome-icon icon="tag" style="margin-right:3px; font-size:10px" />
                    &nbsp;{{ category.topic_name }}
                  </div>
                </div>
              </div> -->
            </div>
            <div class="profile-right">
              <div class="profile-username">
                <div class="profile-username-box accountname" :class="tabs != 'summary' ? 'minimize' : ''">
                  <div>
                    <div>
                      {{ profile_data.account_name }}
                      <font-awesome-icon :icon="['fas', 'check-circle']" v-show="profile_data.verified == '1'" class="tt-badge" style="font-size:18px" />
                      <el-tooltip content="[Adminメニュー] ユーザー名をコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                        <font-awesome-icon
                          v-if="activate == 20 && admin_mode"
                          class="admin-button pointer"
                          :icon="['far', 'copy']"
                          style="margin: 0 10px;"
                          @click="copyLinkName(profile_data.account_name)"
                        />
                      </el-tooltip>
                      <el-tooltip content="[Adminメニュー] データ取得コードをコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                        <font-awesome-icon v-if="activate == 20 && admin_mode" class="admin-button pointer" :icon="['far', 'code']" @click="copyGetLink(profile_data.account_name)" />
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="profile-sort-keyword-wrap">
                    <div v-if="search_type != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      「{{ search_keyword }}」の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="searchMedia('all', '')" />
                    </div>
                    <div v-if="sort_period != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      {{ sort_period == "1month" ? "直近1ヶ月" : sort_period == "3month" ? "直近3ヶ月" : sort_period == "6month" ? "直近6ヶ月" : "" }}の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="sortMediaBy('timestamp', 'all', '投稿日が新しい順')" />
                    </div>
                  </div>
                </div>

                <div class="profile-username-box">
                  <addListDetail
                    ref="add_list_detail"
                    :influencer_id="profile_data.tt_id"
                    :list_count="profile_data.list_count"
                    :add_delete_index="add_delete_index"
                    :add_delete_loading="add_delete_loading"
                    :sns_type="'tiktok'"
                    @addInfluencer="addInfluencer"
                    @deleteInfluencer="deleteInfluencer"
                  />
                  <a :href="'https://www.tiktok.com/@' + profile_data.account_name" target="_blank" class="profile_link">
                    <el-tooltip content="TikTokでアカウントを表示" placement="top">
                      <el-button type="info" style="margin-left:10px;"><font-awesome-icon :icon="['fab', 'tiktok']"/></el-button>
                    </el-tooltip>
                  </a>
                </div>
              </div>
              <div class="profile_follower" v-if="tabs == 'summary' || tabs == 'analysis'">
                <div class="profile_num followers">
                  <div class="num_title">フォロワー数</div>
                  <div>
                    <span class="num">{{ profile_data.followerCount_tt }}</span
                    >万人
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.followerCount_tt / 30) * 100 + '%'" :class="profile_data.followerCount_tt < 1 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num egr">
                  <div class="num_title">
                    平均EGR
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近3ヶ月の1投稿あたりの平均エンゲージメント率(EngagementRate)を示しています。
                        <br />いいね数とコメント数とシェア数の合計をフォロワー数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.engagementRate }}</span
                    >%
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.engagementRate * 100) / 3 + '%'" :class="profile_data.engagementRate < 1 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'summary' || tabs == 'analysis'">
                  <div class="num_title">
                    平均いいね数
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近3ヶ月の1投稿あたりの平均いいね数を示しています。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ averageLikeFormat(profile_data.diggCount) }}</span>
                    <span>{{ profile_data.diggCount >= 10000 ? "万件" : "件" }}</span>
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power"
                         :style="{width: Math.min(100, Math.max(0, ((Number(profile_data.diggCount) || 0) * 100) / 10000)) + '%'}"
                         :class="((Number(profile_data.diggCount) || 0) < 800 ? 'danger' : '')">

                    </div>
                  </div>
                </div>
                <div class="profile_num comment" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均コメント数
                    <el-tooltip placement="top" content="直近3ヶ月の1投稿あたりの平均コメント数を示しています。" :class="printmode ? 'printmode' : ''">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.commentCount }}</span
                    >件
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div class="num_bar_power" :style="'width:' + (profile_data.commentCount * 100) / 50 + '%'" :class="profile_data.commentCount < 10 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num reel_num" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均視聴回数
                    <el-tooltip placement="top">
                      <div slot="content">直近3ヶ月の1投稿あたりの平均視聴回数を示しています。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div class="reel_average_video_play_count">
                    <div class="reel_num_total">
                      合計
                      <div>
                        <span class="num">{{ profile_data.playCount}}</span>
                        万回
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playCount * 3 + '%'" :class="profile_data.playCount < 5 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;(&nbsp;&nbsp;</span>
                    <div class="reel_num_organic video-detail-align">
                      ｵｰｶﾞﾆｯｸ
                      <div>
                        <span class="num">{{ profile_data.playCount_organic}}</span>
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playCount_organic * 3 + '%'" :class="profile_data.playCount_organic < 5 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <div class="reel_num_pr video-detail-align">
                      PR
                      <div>
                        <span class="num">{{ profile_data.playCount_pr }}</span>
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playCount_pr * 3 + '%'" :class="profile_data.playCount_pr < 5 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;)&nbsp;&nbsp;</span>
                  </div>
                </div>
                <div class="profile_num reel_percent" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均視聴率
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近3ヶ月の平均視聴率を示しています。
                        <br />直近3ヶ月の1投稿あたりの平均視聴数をチャンネル登録者数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div class="reel_average_video_play_count">
                    <div class="reel_num_total">
                      合計
                      <div>
                        <span class="num">{{ profile_data.playRate }}</span>
                        %
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playRate + '%'" :class="profile_data.playRate < 20 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;(&nbsp;&nbsp;</span>
                    <div class="reel_num_organic video-detail-align">
                      ｵｰｶﾞﾆｯｸ
                      <div>
                        <span class="num">{{ profile_data.playRate_organic }}</span>
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playRate_organic + '%'" :class="profile_data.playRate_organic < 20 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <div class="reel_num_pr video-detail-align">
                      PR
                      <div>
                        <span class="num">{{ profile_data.playRate_pr }}</span>
                      </div>
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div class="num_bar_power" :style="'width:' + profile_data.playRate_pr + '%'" :class="profile_data.playRate_pr < 20 ? 'danger' : ''"></div>
                      </div>
                    </div>
                    <span class="slash">&nbsp;&nbsp;)&nbsp;&nbsp;</span>
                  </div>
                </div>
                <div class="profile_num pr_rate">
                  <div class="num_title">
                    PR率
                    <el-tooltip placement="top">
                      <div slot="content">直近3ヶ月の投稿に占めるPR投稿の比率です。<br />20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.prRate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + (100 - profile_data.prRate * 3) + '%'" :class="profile_data.prRate > 15 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    平均シェア数
                    <el-tooltip placement="top" content="直近3ヶ月の1投稿あたりの平均シェア数を示しています。" :class="printmode ? 'printmode' : ''">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.shareCount }}</span
                    >件
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div class="num_bar_power" :style="'width:' + (profile_data.shareCount * 100) / 50 + '%'" :class="profile_data.shareCount < 10 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num followers" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    フォロワー増加率
                    <el-tooltip placement="top">
                      <div slot="content">直近3ヶ月間におけるフォロワーの増加率を示しています。</div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span v-if="profile_data.followers_growth_rate_90 > 0">+ </span>
                    <span class="num">{{ profile_data.followers_growth_rate_90 | growthrate }}</span
                    >%
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.followers_growth_rate_90 * 10 + '%'" :class="profile_data.followers_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    平均EGR<br/>(PR投稿のみ)
                    <el-tooltip placement="top">
                      <div slot="content">
                        直近3ヶ月のPR投稿1投稿あたりの平均エンゲージメント率(EngagementRate)を示しています。 <br />いいね数とコメント数の合計をフォロワー数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.engagementRate_pr }}</span
                    >%
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + (profile_data.engagementRate_pr * 100) / 3 + '%'" :class="profile_data.engagementRate_pr < 1 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num" v-if="tabs == 'analysis'">
                  <div class="num_title">
                    投稿頻度
                    <el-tooltip placement="top" content="直近3ヶ月の平均投稿頻度です。">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num">{{ profile_data.media_frequency }}</span
                    >/週
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + (profile_data.media_frequency * 100) / 7 + '%'" :class="profile_data.media_frequency < 1 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div class="profile_num total_post">
                  <div class="num_title">総投稿数</div>
                  <div>
                    <span class="num">{{ profile_data.videoCount }}</span
                    >本
                  </div>
                  <div class="num_bar">
                    <div class="num_bar_power" :style="'width:' + profile_data.videoCount + '%'" :class="profile_data.videoCount < 25 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num">
                  <div class="num_title">総いいね数</div>
                  <div>
                    <span class="num">{{ profile_data.heartCount | viewcount }}</span>
                    <span>{{ profile_data.heartCount > 9999 ? "億回" : "万回" }}</span>
                    <div class="num_bar">
                      <div class="num_bar_power" :style="'width:' + profile_data.heartCount * 3 + '%'" :class="profile_data.heartCount < 5 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>                
              </div>

              <div class="profile-right-center">
                <div class="profile-name-area" v-show="tabs == 'summary'">
                  <div class="profile_name">
                    <div class="profile-feature" v-if="profile_data.nickname">
                      <b>{{ profile_data.nickname }}</b>
                      <span style="margin:0 10px" v-if="profile_data.age || profile_data.gender == '男性' || profile_data.gender == '女性' || profile_data.gender == 'グループ'">|</span>
                    </div>
                    <div class="profile-feature" v-if="profile_data.age">
                      {{ profile_data.age }}歳
                      <el-tooltip :class="printmode ? 'printmode' : ''">
                        <div slot="content">過去の投稿やWebの情報から推測される年齢です。<br />実際の年齢と異なる場合があります。</div>
                        <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
                      </el-tooltip>
                      <span style="margin:0 10px">|</span>
                    </div>
                    <div class="profile-feature" v-if="profile_data.gender == '男性' || profile_data.gender == '女性' || profile_data.gender == 'グループ'">
                      <span v-if="profile_data.gender == '女性'"><font-awesome-icon :icon="['fas', 'female']" style="color:#f56c6c; margin-right: 5px;" />女性</span>
                      <span v-if="profile_data.gender == '男性'"><font-awesome-icon :icon="['fas', 'male']" style="color:#0095f6; margin-right: 5px;" />男性</span>
                      <span v-if="profile_data.gender == 'グループ'"><font-awesome-icon :icon="['fas', 'user-group']" style="color:#aaa; margin-right: 5px;" />グループ</span>
                    </div>
                  </div>
                  <div class="profile_bio">
                    <pre>{{ profile_data.signature }}</pre>
                  </div>
                  <div>
                    <a :href="profile_data.bioLink" v-if="profile_data.bioLink" target="_blank">
                      <span class="profile_website pointer" target="_blank">{{ profile_data.bioLink }}</span>
                    </a>
                  </div>
                </div>
                <!-- スコアアラート -->
                <div class="profile-score-alert-wrap" v-show="tabs == 'analysis' && profile_data.score_alert">
                  <scoreAlert :profile_data="profile_data" />
                </div>
                <div class="flex-space"></div>
                <!-- スコアボード -->
                <div class="profile-score-area" v-show="(tabs == 'summary' || tabs == 'analysis')" :class="printmode ? 'printmode' : ''">
                  <scoreBord :profile_data="profile_data" />
                </div>
              </div>
            </div>
          </div>

          <div class="search-form-youtube" v-if="tabs == 'post'">
            <div class="header-search-wrap instagram" style="width: 180px; margin-right: 10px" :style="inputfocus ? 'width: 100%' : ''">
              <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
              <postSearchInput :inputfocus.sync="inputfocus" :inputkeyword.sync="inputkeyword" @searchKeyword="searchMedia" />
            </div>
            <div class="flex-space"></div>
            <div v-if="tabs == 'post' && video_count > 0">
              <el-pagination
                @current-change="pageChange"
                :current-page.sync="currentPage"
                background
                layout="prev, pager, next"
                :total="video_count"
                :page-size="pagesize"
                :pager-count="5"
                small
              ></el-pagination>
            </div>
            <el-checkbox :value="search_type == 'pr'" @change="search_type == 'pr' ? searchMedia('all', '') : searchMedia('pr', 'PR投稿')" style="display:flex; align-items:center;">
              <el-tooltip placement="bottom">
                <div slot="content">「#PR」などのPR表記のある投稿のみを表示します。</div>
                <span style="font-size:11px; color:#666; ">PR投稿のみを表示</span>
              </el-tooltip>
            </el-checkbox>
            <el-dropdown trigger="click" style="margin-left: 20px">
              <el-button type="info" class="report-media-sort-button">
                {{ media_sort }}
                <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="media_sort == '投稿日が新しい順'" :disabled="media_sort == '投稿日が新しい順'" @click.native="sortMediaBy('timestamp', 'all', '投稿日が新しい順')"
                  >投稿日が新しい順</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近1ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近1ヶ月)'"
                  @click.native="sortMediaBy('playCount', '1month', '再生数が多い順(直近1ヶ月)')"
                  >再生数が多い順(直近1ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近3ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近3ヶ月)'"
                  @click.native="sortMediaBy('playCount', '3month', '再生数が多い順(直近3ヶ月)')"
                  >再生数が多い順(直近3ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(直近6ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(直近6ヶ月)'"
                  @click.native="sortMediaBy('playCount', '6month', '再生数が多い順(直近6ヶ月)')"
                  >再生数が多い順(直近6ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == '再生数が多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == '再生数が多い順(全期間)'"
                  @click.native="sortMediaBy('playCount', 'all', '再生数が多い順(全期間)')"
                  >再生数が多い順(全期間)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近1ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近1ヶ月)'"
                  @click.native="sortMediaBy('engagementCount', '1month', 'エンゲージメントが多い順(直近1ヶ月)')"
                  >エンゲージメントが多い順(直近1ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近3ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近3ヶ月)'"
                  @click.native="sortMediaBy('engagementCount', '3month', 'エンゲージメントが多い順(直近3ヶ月)')"
                  >エンゲージメントが多い順(直近3ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(直近6ヶ月)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(直近6ヶ月)'"
                  @click.native="sortMediaBy('engagementCount', '6month', 'エンゲージメントが多い順(直近6ヶ月)')"
                  >エンゲージメントが多い順(直近6ヶ月)</el-dropdown-item
                >
                <el-dropdown-item
                  :class="media_sort == 'エンゲージメントが多い順(全期間)' ? 'assign' : ''"
                  :disabled="media_sort == 'エンゲージメントが多い順(全期間)'"
                  @click.native="sortMediaBy('engagementCount', 'all', 'エンゲージメントが多い順(全期間)')"
                  >エンゲージメントが多い順(全期間)</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- 投稿リスト部分 -->
          <div v-if="video_count > 0">
            <ul class="gallery-wrap" v-show="profile_data.videoCount > 0 && (tabs == 'summary' || tabs == 'post')">
              <li class="gallery_item tiktok" v-for="(video_data, index) in video_data" :key="video_data.id" @click="detail(index)">
                <div class="mask">
                  <div class="caption tiktok-date">{{ video_data.video_created_at }}</div>
                </div>
                <div class="gallery-item-img tiktok">
                  <div class="pr_type" v-show="video_data.pr_flag">
                    <div class="pr_tag">PR</div>
                  </div>
                  <img class="gallery_img" :src="video_data.post_url + actionId" @load="imgLoaded()" @error="imgError(index)" />
                </div>
                <div class="gallery-indicator">
                  <div><font-awesome-icon :icon="['far', 'play']" style="margin-right: 5px;" />{{ video_data.playCount | addComma }}</div>
                  <div><font-awesome-icon :icon="['far', 'heart']" style="margin-right: 5px;" />{{ video_data.diggCount | addComma }}</div>
                  <div><font-awesome-icon :icon="['far', 'percentage']" style="margin-right: 5px;" />{{ video_data.engagementRate }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="no-media-message" v-else-if="profile_data.private != 1">
            <img src="../../assets/post_image.png" style="opacity:0.5" alt />
            <div>{{ no_media_message }}</div>
          </div>
          <div class="gallery-wrap-private" v-else>このアカウントは非公開か削除されています</div>

          <div class="pagenation-wrap" v-if="(tabs == 'summary' || tabs == 'post') && video_count > 0">
            <el-pagination @current-change="pageChange" :current-page.sync="currentPage" background layout="prev, pager, next" :total="video_count" :page-size="pagesize"></el-pagination>
          </div>

          <div class="overlay-sub overlay" :class="drawer ? 'open' : ''" @click="drawer = false"></div>
          <div class="media-detail-modal tiktok" :class="drawer ? 'open' : ''">
            <div class="detail-modal tiktok" v-if="drawer">
              <div class="detail-profile-wrap">
                <div class="detail-profile-img-area">
                  <el-image class="detail-profile_img" :src="profile_data.profile_picture_url">
                    <div slot="error" class="data-table-profile-noimg">
                      NO
                      <br />IMAGE
                    </div>
                  </el-image>
                </div>
                <div class="detail-profile-name-area">
                  <div class="detail-profile-name">{{ profile_data.account_name }}</div>
                </div>
                <div class="flex-space"></div>
                <div v-if="admin_mode">{{ video_data[index].video_id }}</div>
                <div>
                  <a :href="'https://www.tiktok.com/@' + profile_data.account_name + '/video/' + video_data[index].video_id" target="_blank">
                    <el-button type="info" size="mini" style="margin-left:10px;">TikTok→</el-button>
                  </a>
                </div>
              </div>
              <div class="detail-img-wrap">
                <div class="detail-img-area">
                  <div class="pr_type" v-show="video_data[index].pr_flag">
                    <div class="pr_tag">PR</div>
                  </div>
                  <div class="detail-img-load" v-show="detail_loading"></div>
                </div>
              </div>
              <div class="detail-tiktok">
                <iframe
                  width="320"
                  height="700"
                  :src="'https://www.tiktok.com/embed/' + video_data[index].video_id"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <div class="detail-tiktok-indicator">
                  <div class="detail-engage-area youtube">
                    <div class="detail-engage-box">
                      <div class="detail-engage-tiktok">
                        <div class="detail-engage-tiktok-icon">
                          <font-awesome-icon :icon="['far', 'play']" style="margin-right:3px" />
                        </div>
                        {{ video_data[index].playCount | addComma }}
                      </div>
                      <div class="detail-engage-tiktok">
                        <div class="detail-engage-tiktok-icon">
                          <font-awesome-icon :icon="['far', 'heart']" style="margin-right:3px" />
                        </div>
                        {{ video_data[index].diggCount | addComma }}
                      </div>
                      <div class="detail-engage-tiktok">
                        <div class="detail-engage-tiktok-icon">
                          <font-awesome-icon :icon="['far', 'comment-alt']" style="margin-right:3px" />
                        </div>
                        {{ video_data[index].commentCount | addComma }}
                      </div>
                      <div class="detail-engage-tiktok">
                        <div class="detail-engage-tiktok-icon">
                          <font-awesome-icon :icon="['far', 'share-nodes']" style="margin-right:3px" />
                        </div>
                        {{ video_data[index].shareCount | addComma }}
                      </div>
                      <div class="detail-engage-tiktok">
                        <div class="detail-engage-tiktok-icon">
                          <font-awesome-icon :icon="['far', 'percent']" style="margin-right:3px" />
                        </div>
                        {{ video_data[index].engagementRate }}%
                      </div>
                    </div>
                  </div>
                  <div class="divider-nomargin"></div>
                  <div class="detail-caption-area">
                    <pre
                      class="caption-in"
                      v-html="$options.filters.searchHighlight(video_data[index].description, search_type == 'keyword' ? search_keyword : '', search_type == 'pr' ? true : false)"
                    ></pre>
                    <div class="detail-date">{{ video_data[index].video_created_at }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- フォロワー推移データ -->
          <transitionData :sns_type="'tiktok'" :loading="loading" :id="profile_data.tt_id" v-show="tabs == 'summary' || tabs == 'analysis'" />
          
          <!-- エンゲージメント率の推移 -->
          <transitionData :sns_type="'tiktok_eg'" :loading="loading" :id="profile_data.tt_id" v-show="tabs == 'summary' || tabs == 'analysis'" />
          
          <!-- エンゲージメント分布 -->
          <distributionChart
              :avg_data="avg_data.egr"
              :name="account_name"
              :own_data="profile_data.engagementRate"
              :type="'egr'"
              :sns_type="'tiktok'"
              :followers="profile_data.followerCount"
              v-show="tabs == 'summary' || tabs == 'analysis'"
          />
          
          <!-- １動画あたりの平均視聴回数の推移 -->
          <transitionData :sns_type="'tiktok_average'" :loading="loading" :id="profile_data.tt_id" v-show="tabs == 'summary' || tabs == 'analysis'" />          

          <!-- 視聴率分布 -->
          <distributionChart
              :avg_data="avg_data.vr"
              :name="profile_data.account_name"
              :own_data="profile_data.playRate"
              :type="'vr'"
              :sns_type="'tiktok'"
              :followers="profile_data.followerCount"
              v-show="tabs == 'summary' || tabs == 'analysis'"
          />

          <!-- ノート -->
          <note
            v-if="tabs == 'note'"
            :id="profile_data.tt_id"
            :sns_type="'tiktok'"
            ref="note"
            @commentReactive="commentReactive"
            @statusReactive="statusReactive"
            @noteReactive="noteReactive"
            @tagReactive="tagReactive"
          />

          <div v-observe-visibility="{ callback: similarVisible }"></div>

          <div id="i-detail-similar"></div>

          <!-- 類似アカウント -->
          <similarAccount
            ref="similarAccount"
            v-if="similar_show"
            :sns_type="'tiktok'"
            :similar_data="similar_data"
            @toInfluencerDetail="toInfluencerDetail"
            @toInfluencerDetailNewWindow="toInfluencerDetailNewWindow"
          />
        </div>
      </div>
    </div>
    <div class="loader-detail" v-show="!mounted || loading"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const showTiktokAPI = root + "/api/search/show_tiktok";
const loadSimilarAccountAPI = root + "/api/search/load_similar_tiktok";
const loadListAPI = root + "/api/list/load_list";
const addInfluencerAPI = root + "/api/list/add_influencer";
const deleteInfluencerAPI = root + "/api/list/delete_influencer";
const addFavoriteAPI = root + "/api/list/add_favorite";
const pr_word =
  "sponsored by|【スポンサー】|スポンサー：|スポンサー:|(スポンサー)|（スポンサー）|(▽|▼|○|●|■|□|◆|◇|↓)スポンサー[^ぁ-ん一-龠]|【提供】|^提供:|^提供：|[^楽曲音源映像素材]提供：|[^楽曲音源映像素材]提供:|(提供)|（提供）|(▽|▼|○|●|■|□|◆|◇|↓)提供[^ぁ-ん]|(▽|▼|○|●|■|□|◆|◇|↓)PR提供[^ぁ-ん]";

import transitionData from "./transitionData";
import postSearchInput from "./postSearchInput";
import note from "./note.vue";
import distributionChart from "./detail_component/distribution_chart";
import addListDetail from "./detail_component/add_list_detail";
import otherSNS from "./other_sns.vue";
import similarAccount from "./detail_component/similar_account";
import genderBar from "./detail_component/gender_bar";
import scoreBord from "./scoreBord";
import scoreAlert from "./scoreAlert";
import { handleApiResponse } from "@/components/common/responseHelper";

export default {
  name: "tiktokerDetail",
  components: {
    transitionData,
    postSearchInput,
    note,
    distributionChart,
    addListDetail,
    otherSNS,
    similarAccount,
    genderBar,
    scoreBord,
    scoreAlert
  },
  beforeRouteLeave(to, from, next) {
    if (to.name.match(/tiktokerDetail/i)) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_tiktokerDetailDrawer" : "tiktokerDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else if (to.name == "influencerDetail" && this.child) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    } else {
      next();
    }
  },
  props: {
    account_name: String,
    child: Boolean,
    parent_component: String,
    influencer_index: Number,
    default_search: Boolean,
    search_type: {
      type: String,
      default: "all",
    },
    search_keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tt_id: "",
      currentPage: 1,
      video_count: 0,
      pagesize: 28,
      profile_data: [],
      egr_data: [],
      video_data: [],
      no_media_message: "",
      list: [],
      active_list_count: "",
      sort_key: "timestamp",
      sort_period: "all",
      media_sort: "投稿日が新しい順",
      sort_similar_description: "並び替え",
      mounted: false,
      drawer: false,
      index: 0,
      loading: false,
      add_delete_loading: false,
      add_delete_index: "",
      detail_loading: false,
      img_count: 0,
      inputfocus: false,
      inputkeyword: "",
      actionId: new Date(),
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      get_account_name: "",
      get_account_name_post: "",
      requestId: 0,
      tabs: "summary",
      pr_regexp: "",
      similar_data: [],
      similar_show: false,
      similar_loading: false,
      graph_gender: "全て",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode() {
      return false;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    similar_account() {
      return this.similar_data.slice(0, 5);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.loading = true;
      if (this.default_search == true) {
        this.search_type = this.$route.params.search_type;
        this.search_keyword = this.$route.params.search_keyword;
        this.searchMedia(this.search_type, this.search_keyword);
        this.loadList();
      } else {
        this.axios
          .get(showTiktokAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              account_name: this.account_name,
              search_type: "all",
            },
          })
          .then((response) => {
            if (handleApiResponse(response)) {
              // ステータスがNGの場合
              this.$message.error(response.data.message);
              this.$nextTick(() => {
                this.$router.push({ name: 'tiktoker' });
              });
              return;
            }
            this.mounted = true;
            this.loading = false;
            this.profile_data = response.data.profile_data;
            this.no_media_message = response.data.no_media_message;
            this.avg_data = response.data.avg_data;
            this.video_data = response.data.video_data;
            this.video_count = response.data.video_count;
            this.video_count == 0 ? (this.loading = false) : "";
            this.tt_id = response.data.profile_data.tt_id;
            this.loadSimilarAccount();
          });
      }
    },
    loadSimilarAccount() {
      this.axios.cancel(this.requestId_similar);
      this.requestId_similar += 1;
      this.similar_loading = true;
      this.axios
        .get(loadSimilarAccountAPI, {
          requestId: this.requestId_similar,
          params: {
            token: this.token,
            tt_id: this.tt_id,
          },
        })
        .then((response) => {
          this.similar_data = response.data.similar_data;
          this.similar_loading = false;
        })
        .catch(() => {});
    },
    similarVisible(isVisible) {
      if (isVisible && !this.similar_show) {
        this.similar_show = true;
      }
    },
    loadList() {
      this.axios
        .get(loadListAPI, {
          params: {
            token: this.token,
            type: "min",
            sns_type: "tiktok",
            influencer: this.profile_data.tt_id,
          },
        })
        .then((response) => {
          this.list = response.data.mylist;
          this.active_list_count = response.data.active_list_count;
        });
    },
    addInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const tt_id = this.profile_data.tt_id;
      const tt_id_js = [tt_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(tt_id_js));
      params.append("sns_type", "tiktok");
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count += 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("addInfluencerReactive", this.influencer_index, name, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.account_name + "を" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    deleteInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const tt_id = this.profile_data.tt_id;
      const tt_id_js = [tt_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("sns_type", "tiktok");
      params.append("influencer", JSON.stringify(tt_id_js));
      params.append("token", this.token);
      this.axios.post(deleteInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count -= 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("deleteInfluencerReactive", this.influencer_index, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.profile_data.account_name + "を" + name + "から削除しました",
        });
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    pageChange(currentPage) {
      this.loading = true;
      this.img_count = 0;
      this.currentPage = currentPage;
      this.video_data = [];
      this.requestId += 1;
      this.axios
        .get(showTiktokAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: this.currentPage,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'tiktoker' });
            });
            return;
          }
          this.profile_data = response.data.profile_data;
          this.avg_data = response.data.avg_data;
          this.video_data = response.data.video_data;
          this.video_count = response.data.video_count;
          this.video_count == 0 ? (this.loading = false) : "";
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    searchMedia(type, keyword) {
      this.loading = true;
      this.click_loading = true;
      this.currentPage = 1;
      this.tabs = "post";
      this.img_count = 0;
      if (this.search_type != type || this.search_keyword != keyword) {
        this.media_sort = "投稿日が新しい順";
        this.sort_key = "timestamp";
        this.sort_period = "all";
      }
      if (type !== "keyword") this.inputkeyword = "";
      if (type == "keyword" && keyword == "") type = "all";
      this.search_type = type;
      this.search_keyword = keyword;
      this.requestId += 1;
      this.video_data = [];
      this.axios
        .get(showTiktokAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: 1,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'tiktoker' });
            });
            return;
          }
          if (response.data.video_count == 0) {
            this.no_media_message = response.data.no_media_message;
            this.loading = false;
          }
          this.mounted = true;
          this.profile_data = response.data.profile_data;
          this.tt_id = response.data.profile_data.tt_id;
          this.avg_data = response.data.avg_data;
          this.video_data = response.data.video_data;
          this.video_count = response.data.video_count;
          this.video_count == 0 ? (this.loading = false) : "";
          if (this.search_type == "pr") this.pr_regexp = response.data.search_word;
          this.loadSimilarAccount();
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.actionId += 1;
        });
    },
    sortMediaBy(sort_key, sort_period, sort_description) {
      this.sort_key = sort_key;
      this.sort_period = sort_period;
      this.media_sort = sort_description;
      this.searchMedia(this.search_type, this.search_keyword);
    },
    resetSearchMedia() {
      this.search_type = "all";
      this.search_keyword = "";
      this.sort_key = "timestamp";
      this.sort_period = "all";
      this.media_sort = "投稿日が新しい順";
      this.inputkeyword = "";
      this.currentPage = 1;
    },
    detail(index) {
      (this.drawer = true), (this.index = index);
      this.detail_loading = true;
      this.actionId += 1;
    },
    favorite() {
      if (this.profile_data.favorite == 0) {
        this.profile_data.favorite = 1;
      } else {
        this.profile_data.favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.profile_data.tt_id);
      params.append("sns_type", "tiktok");
      params.append("favorite", this.profile_data.favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
      this.$emit("favoriteReactive", this.influencer_index, this.profile_data.favorite);
    },
    imgLoaded() {
      //imgErrorと併せて読み込み画像数をカウントし、全画像読み込み時にローディング解除
      this.img_count += 1;
      if (this.img_count == this.video_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    imgError(index) {
      this.video_data[index].img_error = true;
      if (this.video_data[index].post_url.match(/_dy\.jpg/)) {
        this.video_data[index].post_url = this.s3BaseUrl + "/tt_postdata/" + this.video_data[index].video_id + "_m.jpg?";
      } else {
        this.video_data[index].post_url = this.s3BaseUrl + "/postdata/error.jpg?";
      }
      this.img_count += 1;
      if (this.img_count == this.video_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    closeParentDrawer() {
      this.drawer = false;
    },
    closeParentDrawerClear() {
      this.resetSearchMedia();
      this.loading = true;
    },
    openParentDrawer() {
      this.child = true;
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    toIDetail(account_name) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    },
    toYDetail(channel_id) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: channel_id,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    },
    changeTab(tab) {
      this.loading = true;
      if (this.tabs == "post" && tab != "post" && (this.search_type != "all" || this.sort_period != "all")) {
        this.resetSearchMedia();
        this.searchMedia("all", "");
        this.tabs = tab;
      } else {
        setTimeout(() => {
          this.tabs = tab;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.loading = false;
        }, 0);
      }
    },
    commentReactive(comment, list_id) {
      this.$emit("commentReactive", this.profile_data.tt_id, comment, list_id);
    },
    statusReactive(status, list_id) {
      this.$emit("statusReactive", this.profile_data.tt_id, status, list_id);
    },
    noteReactive(note_info, property_name) {
      this.$emit("noteReactive", this.profile_data.tt_id, note_info, property_name);
    },
    tagReactive(type, tag_index, new_tag) {
      this.$emit("tagReactive", this.profile_data.tt_id, type, tag_index, new_tag);
    },
    copyLinkName(account_name) {
      var text = account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "ユーザー名がコピーされました",
        });
      });
    },
    copyGetLink(account_name) {
      var text = "php tt_get_single.php -a" + account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "コードがコピーされました",
        });
      });
    },
    scrollBottom() {
      if (this.shimilar_show) {
        document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
      } else {
        this.similar_show = true;
        setTimeout(() => {
          document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
        }, 100);
      }
    },
    toInfluencerDetail(account_name) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_tiktokerDetailDrawer" : "tiktokerDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toInfluencerDetailNewWindow(account_name) {
      let routeData = this.$router.resolve({
        name: "tiktokerDetail",
        params: {
          account_name: account_name,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    averageLikeFormat(val) {
      if (val === null || val === undefined || val === '' || isNaN(val)) {
        return 0;
      }
      const num = Number(val);
      if (num < 10000) {
        return Math.round(num);
      }
      let man = num / 10000;
      let str = man.toFixed(1);
      if (str.endsWith('.0')) {
        str = str.slice(0, -2);
      }
      return str;
    },
  },
  filters: {
    searchHighlight(value, keyword, pr) {
      const url_regexp = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        var return_value = value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else if (pr == true) {
        var pr_regexp = pr_word;
        const keyword_RegExp = new RegExp(pr_regexp, "ig");
        return_value = value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else {
        return_value = value;
      }
      return return_value.replace(url_regexp, (url) => '<a class="router-link" href="' + url + '" target="_blank">' + url + "</a>");
    },
    growthrate(val) {
      if (val == null) {
        return "NA";
      } else {
        return val;
      }
    },
    viewcount(val) {
      if (val >= 9999) {
        return Math.floor(val / 1000) / 10;
      } else {
        return val;
      }
    },
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
  watch: {
    actionId() {
      this.$forceUpdate();
    },
    $route() {
      this.load();
      this.closeParentDrawerClear();
      this.child = true;
    },
    currentPage() {
      if (this.currentPage > 1) this.tabs = "post";
    },
  },
};
</script>

<style></style>
